// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared modal styling for FAL modals */

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.65);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.modal-content {
    background-color: #fff;
    padding: 2rem;
    border-radius: 10px;
    width: 90%;
    max-width: 800px;
    max-height: 90vh;
    overflow-y: auto;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}

.crew-entry {
    margin-bottom: 1.5rem;
}

.form-row {
    display: flex;
    gap: 1rem;
    margin-bottom: 0.75rem;
}

    .form-row input,
    .form-row select {
        flex: 1 1;
        padding: 0.5rem;
        font-size: 0.95rem;
        border: 1px solid #ccc;
        border-radius: 6px;
    }

.modal-actions {
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
    margin-top: 1rem;
}

.save-btn {
    background-color: #007bff;
    color: #fff;
    border: none;
    padding: 0.5rem 1.2rem;
    border-radius: 5px;
    cursor: pointer;
}

.cancel-btn {
    background-color: #6c757d;
    color: #fff;
    border: none;
    padding: 0.5rem 1.2rem;
    border-radius: 5px;
    cursor: pointer;
}

.remove-btn {
    background-color: #dc3545;
    color: #fff;
    border: none;
    padding: 0.35rem 0.8rem;
    border-radius: 5px;
    font-size: 0.85rem;
    cursor: pointer;
}
.large-modal {
    max-width: 1100px;
}

.form-group {
    margin-bottom: 1rem;
}
.modal-container {
    background-color: #fff;
    padding: 30px;
    width: 90%;
    max-width: 900px;
    margin: 5% auto;
    border-radius: 10px;
    overflow-y: auto;
    max-height: 90vh;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);
}

.form-row {
    display: flex;
    gap: 20px;
    margin-bottom: 20px;
    flex-wrap: wrap;
}

    .form-row .MuiFormControl-root {
        flex: 1 1;
        min-width: 240px;
    }

.form-actions {
    display: flex;
    justify-content: space-between;
    margin-top: 30px;
    gap: 10px;
}

.summary-table {
    margin-top: 30px;
    border-top: 1px solid #ccc;
    padding-top: 15px;
}

    .summary-table table {
        width: 100%;
        border-collapse: collapse;
    }

    .summary-table th, .summary-table td {
        border: 1px solid #ddd;
        padding: 8px;
        text-align: left;
    }

    .summary-table th {
        background-color: #f0f0f0;
    }
`, "",{"version":3,"sources":["webpack://./src/pages/demo/PreArrival/FAL/ModalForm.css"],"names":[],"mappings":"AAAA,wCAAwC;;AAExC;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,+BAA+B;IAC/B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,yCAAyC;AAC7C;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,sBAAsB;AAC1B;;IAEI;;QAEI,SAAO;QACP,eAAe;QACf,kBAAkB;QAClB,sBAAsB;QACtB,kBAAkB;IACtB;;AAEJ;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,sBAAsB;IACtB,aAAa;IACb,UAAU;IACV,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,eAAe;AACnB;;IAEI;QACI,SAAO;QACP,gBAAgB;IACpB;;AAEJ;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,iBAAiB;AACrB;;IAEI;QACI,WAAW;QACX,yBAAyB;IAC7B;;IAEA;QACI,sBAAsB;QACtB,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,yBAAyB;IAC7B","sourcesContent":["/* Shared modal styling for FAL modals */\n\n.modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    background: rgba(0, 0, 0, 0.65);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 9999;\n}\n\n.modal-content {\n    background-color: #fff;\n    padding: 2rem;\n    border-radius: 10px;\n    width: 90%;\n    max-width: 800px;\n    max-height: 90vh;\n    overflow-y: auto;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);\n}\n\n.crew-entry {\n    margin-bottom: 1.5rem;\n}\n\n.form-row {\n    display: flex;\n    gap: 1rem;\n    margin-bottom: 0.75rem;\n}\n\n    .form-row input,\n    .form-row select {\n        flex: 1;\n        padding: 0.5rem;\n        font-size: 0.95rem;\n        border: 1px solid #ccc;\n        border-radius: 6px;\n    }\n\n.modal-actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 1rem;\n    margin-top: 1rem;\n}\n\n.save-btn {\n    background-color: #007bff;\n    color: #fff;\n    border: none;\n    padding: 0.5rem 1.2rem;\n    border-radius: 5px;\n    cursor: pointer;\n}\n\n.cancel-btn {\n    background-color: #6c757d;\n    color: #fff;\n    border: none;\n    padding: 0.5rem 1.2rem;\n    border-radius: 5px;\n    cursor: pointer;\n}\n\n.remove-btn {\n    background-color: #dc3545;\n    color: #fff;\n    border: none;\n    padding: 0.35rem 0.8rem;\n    border-radius: 5px;\n    font-size: 0.85rem;\n    cursor: pointer;\n}\n.large-modal {\n    max-width: 1100px;\n}\n\n.form-group {\n    margin-bottom: 1rem;\n}\n.modal-container {\n    background-color: #fff;\n    padding: 30px;\n    width: 90%;\n    max-width: 900px;\n    margin: 5% auto;\n    border-radius: 10px;\n    overflow-y: auto;\n    max-height: 90vh;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);\n}\n\n.form-row {\n    display: flex;\n    gap: 20px;\n    margin-bottom: 20px;\n    flex-wrap: wrap;\n}\n\n    .form-row .MuiFormControl-root {\n        flex: 1;\n        min-width: 240px;\n    }\n\n.form-actions {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 30px;\n    gap: 10px;\n}\n\n.summary-table {\n    margin-top: 30px;\n    border-top: 1px solid #ccc;\n    padding-top: 15px;\n}\n\n    .summary-table table {\n        width: 100%;\n        border-collapse: collapse;\n    }\n\n    .summary-table th, .summary-table td {\n        border: 1px solid #ddd;\n        padding: 8px;\n        text-align: left;\n    }\n\n    .summary-table th {\n        background-color: #f0f0f0;\n    }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
